// extracted by mini-css-extract-plugin
export default {"VideoReport":"styles_VideoReport__GUpVx","pagination":"styles_pagination__gIp+Y"};